module.exports = __webpack_public_path__ + "img/State=18.45e80671.svg";